import { render, staticRenderFns } from "./PageEducatorInstitutionTeacher.vue?vue&type=template&id=57a5541d&scoped=true&"
import script from "./PageEducatorInstitutionTeacher.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionTeacher.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionTeacher.vue?vue&type=style&index=0&id=57a5541d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5541d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
